/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */
import * as React from 'react';

import { Page } from 'components';
import { History, Location } from 'history';
import { match as Match } from 'react-router-dom';
import { SetupGame as SetupGameCtrl } from './components/setupGame';
import { Dimensions } from 'components/board/chessTypes';
import Measure from 'react-measure';
import { GameState } from 'contexts/gameStateContext';
import { AppEventsContext } from 'contexts/appEventsContext';

export interface SetupGameViewProps {
  match: Match<{}>;
  history: History;
  location: Location;
}

export interface SetupGameViewState {
  bounds?: Dimensions;
  game: GameState;
}

/** SetupGame */
export class SetupGameView extends React.Component<SetupGameViewProps, SetupGameViewState> {
  constructor(props: any, ctx: any) {
    super(props, ctx);
    this.state = {
      game: new GameState()
    };
  }

  render() {
    return (
      <Measure bounds onResize={(data) => this.setState({ bounds: data.bounds as Dimensions })}>
        {({ measureRef }) => {
          return (
            <AppEventsContext>{events => (
              <Page title="Play Chess" style={{ overflow: 'hidden', padding: 0 }}>
                <div ref={measureRef} className="chess-area flex fill column col-1">
                  {!!this.state.bounds && (
                    <SetupGameCtrl {...this.props} bounds={this.state.bounds} game={this.state.game} events={events} />
                  )}
                </div>
              </Page>
            )}</AppEventsContext>
          );
        }}
      </Measure>
    );
  }
}

export default SetupGameView;



// WEBPACK FOOTER //
// ./src/views/setupGame/index.tsx